var render = function render(){var _vm=this,_c=_vm._self._c;return _c('img',_vm._b({class:_vm.loaded ? 'site-image loaded' : 'site-image',attrs:{"src":_vm.dataUrl,"alt":_vm.$attrs.alt || '',"loading":"lazy","width":_vm.placeholder ? _vm.placeholder.width : undefined,"height":_vm.placeholder ? _vm.placeholder.height : undefined},on:{"load":function($event){_vm.loaded = true}}},'img',_vm.$attrs,false))
}
var staticRenderFns = []

export { render, staticRenderFns }